import React, { useState, useEffect } from 'react';
import { FormGroup, Row, Col } from 'reactstrap';
import { useQuery } from 'react-query';
import Select from 'react-select';
import ProductListItem from './ProductListItem';
import CustomLoader from './CustomLoader';
import { useLocation } from 'react-router-dom';
import { customSelectStyles } from '../scripts/selectStyle';

const productTypes = [
	{ label: 'Современная', value: 0 },
	{ label: 'Классика', value: 1 },
	{ label: 'Неоклассика', value: 2 }
];

const parseQuery = (queryString) => {
	if (!queryString) return {};
	const query = {};
	const pairs = queryString.replace('?', '').split('&').filter(Boolean);

	for (let i = 0; i < pairs.length; i++) {
		const pair = pairs[i].split('=');
		query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
	}
	return query;
};

const fetchGalleryWorks = async (type) => {
	const data = new FormData();
	data.append('type', type);

	const response = await fetch('api/DataforDB/GetGalleryWorks', {
		method: 'POST',
		body: data,
	});

	if (!response.ok) {
		throw new Error('Ответ сети был неудовлетворительным');
	}

	return response.json();
};

export const Gallery = () => {
	const location = useLocation();

	const [typeProduct, setTypeProduct] = useState(null);

	const initialFilter = parseQuery(location.search).filter;
	const [filterType, setFilterType] = useState(
		initialFilter !== undefined ? Number(initialFilter) : -1
	);

	const { data: products, error, isLoading, refetch } = useQuery(
		['galleryWorks', filterType],
		() => fetchGalleryWorks(filterType),
		{ enabled: false }
	);

	useEffect(() => {
		refetch();
	}, [filterType, refetch]);

	const handleFilterChange = (value) => {
		const type = value ? value.value : -1;
		setTypeProduct(value);
		setFilterType(type);
	};

	if (isLoading) return <CustomLoader visible={true} />;

	if (error) {
		return (
			<div className="alert alert-danger">
				Ошибка загрузки: {error.message}
			</div>
		);
	}

	return (
		<>
			<h1>Каталог</h1>

			<FormGroup>
				<label for='product-type'>Тип кухни</label>
				<Select
					id={'product-type'}
					className={'select-style'}
					value={productTypes.find(x => x.value === filterType) || null}
					options={productTypes}
					placeholder="Выберите тип кухни"
					isClearable
					onChange={handleFilterChange}
					styles={customSelectStyles}
				/>
			</FormGroup>

			{products?.length ? (
				<Row className="products-area">
					{products.map(p => (
						<Col sm={6} md={4} key={p.id}>
							<ProductListItem product={p} type={0} />
						</Col>
					))}
				</Row>
			) : (
				<FormGroup xs={12} className="alert alert-primary">
					Не найдено товаров
				</FormGroup>
			)}
		</>
	);
};